module.exports = __webpack_public_path__ + "img/course_005.c523d88.webp";